import { useNavigate } from 'react-router-dom'

import { useControlledHotkeys } from '../../common/hooks/useControlledHotkeys.js'
import { CommandBarActionType } from '../types.js'

export const CommandBarHotKey = ({
  actionItem,
}: {
  actionItem: CommandBarActionType
}) => {
  const navigate = useNavigate()

  useControlledHotkeys(actionItem?.hotkey, e => {
    e.preventDefault()

    if (!actionItem?.action && !actionItem?.url) {
      return undefined
    }

    if (typeof actionItem?.action === 'function') {
      return actionItem.action()
    }

    return navigate(actionItem?.url)
  })

  return null
}
